import { Text, ClickInterface } from '@/entities/app/interfaces'
import { Button } from '@chakra-ui/react'

const Submit: React.FC<Text & ClickInterface & { bg?: string, type? : 'submit' | 'button' }> = ({
	text,
	click,
	bg = 'black',
	type = 'submit'
}) => {
	return (
		<Button
			p='4'
			bg={bg}
			color='white'
			border='none'
			fontSize='lg'
			fontWeight='800'
			borderRadius='lg'
			type={type}
			onClick={click}
		>
			{text}
		</Button>
	)
}

export default Submit
